<template>

<div>

	<div class="page-header">
		<h1><lang labelKey="HEADER_TEMPLATES"></lang></h1>
	</div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>


	<div class="columns" v-if="!isLoading">

		<div class="col-main">


			<div class="tblWrapper templates">

				<v-client-table :data="templates" :columns="tblColumns" :options="tblOptions">

					<template slot="type" slot-scope="props">
						{{ $t('EMAIL-TEMPLATE_TYPE-' + getTemplateType(props.row.type)) }}
					</template>

					<template slot="delete" slot-scope="props">
						<pop-confirm :content="$t('CONFIRMATION-DELETE_TEMPLATE')" icon="question-circle-o" :on-ok="function() { templateDelete(props)}">
							<span class="icon is-small"><i class="icon-ak-entfernen"></i></span>
						</pop-confirm>
					</template>

				</v-client-table>

			</div>

		</div>

		<div class="col-aside">

            <affix :offset="0">
				<!--<custom-button type="blue" name="SECTIONS_BTN-SECTION_ADD" icon="fa fa-plus" @click.native="sectionAdd"></custom-button>-->
				<custom-button type="blue" name="MAILTEMPLATE_BTN-TEMPLATE_ADD" icon="icon-ak-hinzufuegen" @click.native="templateAdd"></custom-button>
			</affix>

		</div>

	</div>

</div>
</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');
// Vue.use(ClientTable, {}, false, 'bulma', 'defaultApokat');

export default {
	name: 'templates',
	data() {
		return {
			isLoading: false,
			templates: [],
			tblColumns: ['name', 'type', 'delete'],
			tblOptions: {
				saveState: true,
				perPage: 25,
				orderBy: {
					ascending: true,
					column: 'name'
				},
				headings: {
					name: function(h) {
						return <lang labelKey="TEMPLATES_TBL_HEADER-NAME"></lang>
					},
                    type: function(h) {
						return <lang labelKey="TEMPLATES_TBL_HEADER-TYPE"></lang>
					},
					delete: function(h) {
						return <lang labelKey="TEMPLATES_TBL_HEADER-DELETE"></lang>
					}
				},
				filterByColumn: true,
				filterable: ['name', 'type'],
				sortable: ['name', 'type'],
				sortIcon: {
					base:'fa',
					up:'fa-sort-up',
					down:'fa-sort-down',
					is:'fa-sort'
				},
				texts: {
					filter: 'Filter Ergebnisse:',
					filterPlaceholder: 'Suche',
					limit: 'Einträge pro Seite',
					noResults: 'keine passenden Einträge gefunden',
					count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
				},
				pagination: {
					chunk: 5
				},
				skin: 'table is-striped is-hoverable is-fullwidth',

                rowClassCallback: function(row) {
                    return `row-${row.id}`;
                }
			}
		}
	},

    computed: {

        mailTemplateTypes() {
            return this.$store.getters.getTermsByTaxonomy('MAIL_TEMPLATE_TYPES');
        }

    },

    created() {

        this.fetchData();

    },

	mounted() {


	},

    updated() {

		var self = this;

		$(".templates table tbody > tr").unbind("click").on("click", function() {
			var id = this.className.split("-")[1];
			self.$router.push('/einstellungen/email-templates/template-' + id);
		});

	},


	methods: {


		getTemplateType(typeId) {

			for (var key in this.mailTemplateTypes) {
			    if (!this.mailTemplateTypes.hasOwnProperty(key)) continue;
			    var obj = this.mailTemplateTypes[key];
			    for (var prop in obj) {
			        if(!obj.hasOwnProperty(prop)) continue;
					if(obj[prop] == typeId) {
						return obj.name;
					}
			    }
			}

		},

		fetchData() {

            this.isLoading = true;
            var self = this;

            // fetch data
            this.axios.get(this.$config.api + 'mailTemplate')
                .then(function(response) {
					self.templates = response.data.mailTemplate;
                    self.isLoading = false;
                }).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });

        },


		templateAdd() {

    		this.$router.push('/einstellungen/email-templates/neu');

        },


		templateDelete(props) {

            var self = this;

            // fetch data
            this.axios.delete(this.$config.api + 'mailTemplate/'+props.row.id)
                .then(function(response) {

					self.templates.splice(props.index, 1);
                    // self.isLoading = false;
					self.$notify.success({content: self.$t('MSG-SUCCESS-TEMPLATE_SCCESSFULLY_DELETED')});

                }).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });


		}


	}
}
</script>


<style>
	.templates thead th:last-child {
	    width: 100px;
	    text-align: center;
	}
	.templates td:last-child {
	    text-align: center;
	}
</style>
